import { render, staticRenderFns } from "./ruku.vue?vue&type=template&id=7b14fb5c&scoped=true&"
import script from "./ruku.vue?vue&type=script&lang=js&"
export * from "./ruku.vue?vue&type=script&lang=js&"
import style0 from "./ruku.vue?vue&type=style&index=0&id=7b14fb5c&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b14fb5c",
  null
  
)

export default component.exports